import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import CertificateOverview from '../views/CertificateOverview.vue'
import CertificateDetail from '../views/CertificateDetail.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        children: [
            {
                path: 'login',
                name: 'Login',
                component: Login
            },
            {
                path: 'certificateoverview',
                name: 'CertificateOverview',
                component: CertificateOverview
            },
            {
                path: 'certificatedetail',
                name: 'CertificateDetail',
                component: CertificateDetail
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'hash', //causes problems if page is hosted in cmPortal - so use the default 'hash' mode
    base: process.env.BASE_URL,
    routes
})

export default router
